






















































































































































































































































import Vue, { PropType } from 'vue';
import truffleKitIcons from '@/utils/truffleKitIcons';
import { TCollectionIcons, TLocalErrorFieldInput } from '@/types';
import VALIDATION from '@/utils/validationFields';
import _ from 'lodash';

export default Vue.extend({
  name: 'FieldInput',
  props: {
    id: {
      type: String,
      required: false,
      default: '',
    },
    name: { type: String },
    value: {
      type: [String, Number],
      default: '',
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
    placeholder: { type: String },
    hint: { type: String },
    prefix: { type: String },
    postfix: { type: String },
    maxSymbol: {
      type: Number,
      default: 0,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '40px',
    },
    showPasswordButton: {
      type: Boolean,
      default: false,
    },
    helpText: {
      type: String,
      required: false,
      default: '',
    },
    validate: {
      type: Array as PropType<Array<string>>,
      required: false,
      default: () => [],
    },
    dataTestId: {
      type: String,
      required: false,
      default: '',
    },
    mask: {
      type: String,
      required: false,
      default: '',
    },
  },
  mounted(): void {
    this.setFieldValue(this.value);
    if (this.validate.length) {
      this.$store.commit('setValidationErrors', this.localErrors);
    }
  },
  beforeDestroy() {
    if (this.validate.length && this.$store.state.validationErrors.length) {
      this.$store.commit('removeLastValidationErrors', this.localErrors.id);
    }
    this.clearErrors();
  },
  watch: {
    value: function (value: string) {
      this.setFieldValue(value);
    },
    errors(newValue: Array<string>): void {
      this.localErrors.errors = newValue;
    },
  },
  computed: {
    getId(): string {
      if (!this.name) {
        return '_' + Math.random().toString(36).substr(2, 9);
      }
      return this.name.replace('[', '-').replace(']', '').toLowerCase();
    },
    issetLabel(): boolean {
      return this.label !== '';
    },
    isFilled(): boolean {
      return this.fieldValue !== null && this.fieldValue !== '';
    },
    errorCountSymbol(): boolean {
      return this.maxSymbol < this.countSymbol;
    },
    symbolLeft(): number {
      if (!this.maxSymbol) {
        return 0;
      }
      return this.maxSymbol - this.countSymbol;
    },
    countSymbol(): number {
      return this.fieldValue.length;
    },
    error(): string {
      return this.errors.join(', ');
    },
    isErrors(): boolean {
      return this.localErrors.errors.length > 0;
    },
    validateErrors(): string {
      return this.localErrors.errors.join(', ');
    },
    truffleKitIcons(): TCollectionIcons {
      return truffleKitIcons;
    },
  },
  methods: {
    setFieldValue(value: string | number) {
      if (value == 'null' || value == null) {
        this.fieldValue = '';
      } else {
        this.fieldValue = value + '';
      }
    },
    input() {
      this.validationFieldValue();
      this.$emit('input', this.fieldValue.toString());
    },
    change() {
      this.validationFieldValue();
      this.$emit('change', this.fieldValue.toString());
    },
    focus(data) {
      this.clearErrors();
      this.$emit('focus', data);
    },
    blur() {
      this.validationFieldValue();
      this.$emit('blur');
    },
    keyupEnter() {
      this.validationFieldValue();
      this.$emit('keyupEnter', this.fieldValue.toString());
      this.fieldValue = '';
    },
    validationFieldValue(): void {
      if (this.validate.length) {
        this.validate.forEach((valid: string) => {
          VALIDATION[valid](this.fieldValue, this.localErrors.errors);
        });
      }
    },
    clearErrors() {
      if (this.validate.length) {
        this.localErrors.errors.splice(0, this.localErrors.errors.length);
      }
    },
  },
  data: function () {
    return {
      fieldValue: '',
      showPassword: false,
      localErrors: {
        id: _.uniqueId(),
        errors: this.errors,
      } as TLocalErrorFieldInput,
    };
  },
});
